import * as React from "react";
import type { SVGProps } from "react";
const SvgMedal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    fill="none"
    {...props}
  >
    <g filter="url(#medal_svg__a)">
      <path
        fill="url(#medal_svg__b)"
        d="M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12"
      />
    </g>
    <path
      fill="url(#medal_svg__c)"
      fillRule="evenodd"
      stroke="url(#medal_svg__d)"
      strokeMiterlimit={22.926}
      strokeWidth={0.183}
      d="M13 1c6.628 0 12 5.373 12 12 0 6.628-5.373 12-12 12-6.628 0-12-5.373-12-12C1 6.372 6.373 1 13 1Zm0 2.148c5.44 0 9.852 4.41 9.852 9.852 0 5.44-4.41 9.852-9.852 9.852-5.44 0-9.852-4.41-9.852-9.852 0-5.44 4.41-9.852 9.852-9.852Z"
      clipRule="evenodd"
    />
    <g filter="url(#medal_svg__e)">
      <path
        fill="url(#medal_svg__f)"
        d="M13.25 6.89a.736.736 0 0 0-.717.729c0 .42.286.644.69.644h.939s.717 0 .717.672c0 .673-.717.673-.717.673h-5.63a.736.736 0 0 0-.718.728c0 .392.33.728.717.728h3.92s.717 0 .717.673c0 .672-.717.672-.717.672H9.387a.736.736 0 0 0-.718.728c0 .392.331.729.718.729h3.091s.718 0 .718.672-.718.672-.718.672h-.22a.736.736 0 0 0-.718.728c0 .393.33.729.717.729h1.932s.718 0 .718.672-.718.672-.718.672h-4.085a.736.736 0 0 0-.717.729c0 .392.331.728.717.728h5.603c.608 0 1.132-.308 1.436-.812q.681-1.155 1.352-2.311c.449-.77.897-1.541 1.352-2.311a1.72 1.72 0 0 0 0-1.71q-.68-1.155-1.352-2.31-.67-1.155-1.352-2.311a1.69 1.69 0 0 0-1.436-.812z"
      />
      <path
        fill="url(#medal_svg__g)"
        d="M9.387 7.619c0-.392.33-.728.717-.728h.994c.386 0 .718.336.718.728a.736.736 0 0 1-.718.728h-.994a.736.736 0 0 1-.717-.728"
      />
      <path
        fill="url(#medal_svg__h)"
        d="M6.24 13.193c0-.392.331-.728.718-.728h.276c.386 0 .717.336.717.728a.736.736 0 0 1-.717.729h-.276a.736.736 0 0 1-.718-.729"
      />
      <path
        fill="url(#medal_svg__i)"
        d="M8.531 15.238a.736.736 0 0 0-.717.728c0 .42.33.757.717.729h1.573a.736.736 0 0 0 .718-.729.736.736 0 0 0-.718-.728z"
      />
    </g>
    <defs>
      <linearGradient
        id="medal_svg__b"
        x1={13}
        x2={13}
        y1={3.536}
        y2={21.564}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.179} stopColor="#FFCD61" />
        <stop offset={0.804} stopColor="#E4772C" />
      </linearGradient>
      <linearGradient
        id="medal_svg__c"
        x1={13}
        x2={13}
        y1={1}
        y2={25}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.049} stopColor="#FBFCCF" />
        <stop offset={0.393} stopColor="#F4BE5A" />
        <stop offset={0.84} stopColor="#DD7122" />
      </linearGradient>
      <linearGradient
        id="medal_svg__d"
        x1={13}
        x2={13}
        y1={1}
        y2={25}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.042} stopColor="#fff" />
        <stop offset={0.114} stopColor="#CB983C" />
        <stop offset={0.49} stopColor="#F0B245" />
        <stop offset={1} stopColor="#FFAB4F" stopOpacity={0.47} />
      </linearGradient>
      <linearGradient
        id="medal_svg__f"
        x1={13.158}
        x2={13.158}
        y1={6.891}
        y2={19.468}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E47E33" />
        <stop offset={1} stopColor="#C25615" />
      </linearGradient>
      <linearGradient
        id="medal_svg__g"
        x1={13.158}
        x2={13.158}
        y1={6.891}
        y2={19.468}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E47E33" />
        <stop offset={1} stopColor="#C25615" />
      </linearGradient>
      <linearGradient
        id="medal_svg__h"
        x1={13.158}
        x2={13.158}
        y1={6.891}
        y2={19.468}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E47E33" />
        <stop offset={1} stopColor="#C25615" />
      </linearGradient>
      <linearGradient
        id="medal_svg__i"
        x1={13.158}
        x2={13.158}
        y1={6.891}
        y2={19.468}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E47E33" />
        <stop offset={1} stopColor="#C25615" />
      </linearGradient>
      <filter
        id="medal_svg__a"
        width={24}
        height={24.734}
        x={1}
        y={1}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={2.201} />
        <feGaussianBlur stdDeviation={0.367} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.764706 0 0 0 0 0.345098 0 0 0 0 0.0862745 0 0 0 0.6 0" />
        <feBlend in2="shape" result="effect1_innerShadow_24015_22357" />
      </filter>
      <filter
        id="medal_svg__e"
        width={13.836}
        height={12.945}
        x={6.24}
        y={6.891}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.073} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_24015_22357"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_24015_22357"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={0.367} />
        <feGaussianBlur stdDeviation={0.183} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
        <feBlend in2="shape" result="effect2_innerShadow_24015_22357" />
      </filter>
    </defs>
  </svg>
);
export default SvgMedal;
